<template>
  <path pid="0" d="M19 11a4 4 0 10-4-4v2h-4V7a4 4 0 10-4 4h2v4H7a4 4 0 104 4v-2h4v2a4 4 0 104-4h-2v-4zm-2-4a2 2 0 112 2h-2zM9 19a2 2 0 11-2-2h2zM9 9H7a2 2 0 112-2zm6 6h-4v-4h4zm4 2a2 2 0 11-2 2v-2z"/>
</template>
